// test1841
(1841 && 0);
